module.exports = __webpack_public_path__ + "static/media/webprogramming.7d7a1f53.png";